<template>
    <div v-if="show" class="fixed inset-0 z-[110] flex items-center justify-center bg-black/40 px-4"
        @click.self="$emit('close')">
        <div class="w-full max-w-xl rounded-lg bg-white p-6 shadow-lg">
            <div class="flex items-start justify-between gap-4">
                <div>
                    <h2 class="text-xl font-semibold text-gray-800">{{ title }}</h2>
                    <p class="text-sm text-gray-500">{{ subtitle }}</p>
                </div>
                <button type="button" class="text-gray-500 hover:text-gray-700" @click="$emit('close')">
                    <font-awesome-icon icon="fa-xmark" />
                </button>
            </div>

            <div class="mt-4">
                <input type="text"
                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
                    :placeholder="searchPlaceholder" v-model="searchQuery" />
            </div>

            <div class="mt-6 max-h-80 divide-y overflow-y-auto rounded-lg">
                <div v-if="loading" class="py-6 text-center text-gray-500">
                    Carregando...
                </div>

                <div v-else>
                    <p v-if="entities.length === 0" class="py-6 text-center text-gray-500">
                        {{ emptyMessage }}
                    </p>

                    <ul v-else>
                        <li v-for="entity in entities" :key="entity.id"
                            class="flex items-start justify-between gap-4 py-3">
                            <div>
                                <p class="font-semibold text-gray-800">{{ getEntityName(entity) }}</p>
                                <p class="text-sm text-gray-500">{{ getEntityInfo(entity) }}</p>
                            </div>

                            <button type="button" class="btn-purple whitespace-nowrap" @click="$emit('select', entity)"
                                :disabled="creating">
                                {{ buttonText }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Iniciar nova conversa'
        },
        subtitle: {
            type: String,
            default: 'Selecione um item para começar a conversar.'
        },
        searchPlaceholder: {
            type: String,
            default: 'Buscar...'
        },
        emptyMessage: {
            type: String,
            default: 'Nenhum item disponível para iniciar conversa.'
        },
        buttonText: {
            type: String,
            default: 'Iniciar conversa'
        },
        entities: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        creating: {
            type: Boolean,
            default: false
        },
        getEntityName: {
            type: Function,
            default: (entity) => entity.name || 'Desconhecido'
        },
        getEntityInfo: {
            type: Function,
            default: (entity) => entity.cnpj ? `CNPJ: ${entity.cnpj}` : 'Não informado'
        }
    },

    emits: ['close', 'select', 'search'],

    setup(props, { emit }) {
        const searchQuery = ref('')
        let debounceTimeout = null

        watch(searchQuery, (newValue) => {
            if (debounceTimeout) {
                clearTimeout(debounceTimeout)
            }

            debounceTimeout = setTimeout(() => {
                emit('search', newValue)
            }, 300)
        })

        watch(() => props.show, (newValue) => {
            if (newValue) {
                searchQuery.value = ''
            }
        })

        return {
            searchQuery
        }
    }
}
</script>
